package com.cs.ejobin.navigation

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

enum class NavAction { Navigate, Reset, Pop, External }

class NavController(start: Screen) {
    private val backStack = ArrayDeque<Screen>().apply { add(start) }

    private val _current = MutableStateFlow(start)
    val current: StateFlow<Screen> = _current.asStateFlow()

    private val _lastAction = MutableStateFlow(NavAction.Reset)
    val lastAction: StateFlow<NavAction> = _lastAction.asStateFlow()

    fun navigate(screen: Screen) {
        backStack.addLast(screen)
        _current.value = screen
        _lastAction.value = NavAction.Navigate
    }

    fun pop(): Boolean {
        if (backStack.size <= 1) return false
        backStack.removeLast()
        _current.value = backStack.last()
        _lastAction.value = NavAction.Pop
        return true
    }

    fun resetTo(screen: Screen) {
        backStack.clear()
        backStack.addLast(screen)
        _current.value = screen
        _lastAction.value = NavAction.Reset
    }

    /**
     * Utilisé côté Web quand le navigateur change l'URL (popstate).
     * On considère alors que la source de vérité est externe, et on ne doit
     * pas ré-écrire l'historique (replaceState/pushState).
     */
    fun setFromWeb(screen: Screen) {
        backStack.clear()
        backStack.addLast(screen)
        _current.value = screen
        _lastAction.value = NavAction.External
    }
}